import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Breadcrumb, Button, message } from "antd";
import { ArrowLeftOutlined, InfoCircleOutlined, CloseCircleOutlined, EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import CustomerMainLayout from "../CustomerMainLayout";
import AiLoader from "../../AiAsserCreate/AiLoader";
import { AI_IMAGE_GET_REJECTIONS, CREATE_COLLABORATE_ENTITY } from "../../../../environments/env";
import "./RejectionHistoryPage.scss";

const getInitials = (name) => {
  if (!name) return '';

  const parts = name.trim().split(/[\s_]+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return parts.map(part => part.charAt(0).toUpperCase()).join('').substring(0, 2);
};

const RejectionHistoryPage = ({ history, location }) => {
  const [rejections, setRejections] = useState([]);
  const [imageInfo, setImageInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collaborating, setCollaborating] = useState(null);

  // Get image info from location state or query params
  const imageId = location.state?.imageId || new URLSearchParams(location.search).get('imageId');
  const imageTitle = location.state?.imageTitle || 'Untitled Image';
  const createdBy = location.state?.createdBy || '';
  const createdOn = location.state?.createdOn || '';
  const collabId = location.state?.collabId || '';

  useEffect(() => {
    if (imageId) {
      fetchRejectionHistory();
    }
  }, [imageId]);

  const fetchRejectionHistory = async () => {
    try {
      setLoading(true);
      const response = await axios.post(AI_IMAGE_GET_REJECTIONS, {
        image_id: imageId
      });

      console.log('Rejection history response:', response);

      if (response.data && response.data) {
        setRejections(response.data);
      }

      if (response.data && response.data.image_info) {
        setImageInfo(response.data.image_info);
      }
    } catch (error) {
      console.error('Error fetching rejection history:', error);
      message.error('Failed to load rejection history');
    } finally {
      setLoading(false);
    }
  };

  const handleViewCollaboration = async (rejection) => {
    const collabLink = collabId;


    setCollaborating(rejection.id || rejection.qa_time);

    if(collabId){
      window.location.href = `/collaborate-tool/${collabLink}?ai_image=true`;
    } else{
      console.error('Error opening collaboration:');
      message.error('Failed to open collaboration');
      setCollaborating(null);
    } 
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const utcDateString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
    const date = new Date(utcDateString);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };

    return date.toLocaleDateString('en-US', options);
  };

  const getRejectionNumber = (index) => {
    return rejections.length - index;
  };

  if (loading) {
    return (
      <CustomerMainLayout selected="31">
        <div className="rejection-history-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 200px)', width: '100%' }}>
          <AiLoader />
        </div>
      </CustomerMainLayout>
    );
  }

  return (
    <CustomerMainLayout selected="31">
      <div className="rejection-history-page">
        <div className="breadcrumb-container">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            className="back-button"
            onClick={() => history.push('/review-images')}
          />
          <Breadcrumb className="page-breadcrumb">
            <Breadcrumb.Item>
              <a onClick={() => history.push('/review-images')}>Review Images</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Rejection History</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="page-header">
          <h1 className="page-title">Rejection History</h1>
          <div className="image-info">
            <span className="image-title">{imageInfo?.title || imageTitle}</span>
            <span className="image-meta">
              Created on {formatDate(imageInfo?.created_on || createdOn)} by {imageInfo?.created_by || createdBy}
            </span>
          </div>
        </div>

        
          {rejections.length === 0 ? (
            <div>
              <div className="empty-state">
                <p>No rejection history found for this image.</p>
              </div>
            </div>
          ) : 
          <div className="rejections-list">
          {
            rejections.map((rejection, index) => (
              <div key={rejection.qa_time || index} className="rejection-card">
                <div className="rejection-header">
                  <div className="rejection-user-info">
                    <div className="user-avatar">
                      {getInitials(rejection.qa_person || rejection.rejected_by || rejection.done_by)}
                    </div>
                    <div className="rejection-meta">
                      <span className="user-name">{rejection.qa_person || rejection.rejected_by || rejection.done_by}</span>
                      <span className="rejection-time">
                        Rejected on {formatDate(rejection.qa_time || rejection.rejected_on || rejection.updated_on)}
                      </span>
                    </div>
                  </div>

                  {(rejection.feedback_link || rejection.collab_id || collabId) && (
                    <Button
                      className="view-collab-btn"
                      onClick={() => handleViewCollaboration(rejection)}
                      loading={collaborating === (rejection.id || rejection.qa_time)}
                    >
                      <img src="/img/ai_creator/collab.svg" alt="" className="collab-icon" />
                      View Collaboration
                    </Button>
                  )}
                </div>

                <div className="rejection-reason-box">
                  <div className="reason-number">
                    {getRejectionNumber(index)}
                  </div>
                  <div className="reason-text">
                    {rejection.rejection_details || rejection.reason || rejection.rejection_reason || 'Rejected by reviewer'}
                  </div>
                </div>
              </div>
            ))
          }
          </div>
          }
      </div>
    </CustomerMainLayout>
  );
};

export default withRouter(RejectionHistoryPage);
